import i18next, { type TFunction } from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'
import type { EN } from './locales/EN.ts'

i18next.use(initReactI18next).use(
	resourcesToBackend(async (lang: string, ns: string) => {
		if (lang === 'EN') {
			return (await import('./locales/EN.ts')).EN[ns as keyof typeof EN]
		}
		return (await import(`./locales/${lang}.json`))[ns]
	}),
)

// see https://www.i18next.com/overview/typescript
declare module 'i18next' {
	interface CustomTypeOptions {
		enableSelector: true
		resources: typeof EN
	}
}

export type I18nKey = Parameters<TFunction>[0]
